import { OmtScroll } from "./OmtScroll";

const IMAGES = [
  "https://images.unsplash.com/photo-1488345979593-09db0f85545f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  "https://images.unsplash.com/photo-1789700536824-25581b5732ab?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "https://images.unsplash.com/photo-1785057707880-777f72acea8f?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
];

const HAVE = [
  { from: "泳池・健身房", to: "運動處方" },
  { from: "三溫暖・SPA", to: "修復療程" },
  { from: "多元餐飲", to: "抗老飲食" },
  { from: "花園・客房", to: "好眠住房" },
];

const EXAMPLES = [
  { name: "Clinique La Prairie", place: "瑞士・蒙特勒", text: "長壽與回春療程，全球抗老的代名詞" },
  { name: "Lanserhof Tegernsee", place: "德國・泰根湖", text: "醫學級長壽計畫，結合運動、睡眠與營養" },
  { name: "Chenot Palace Weggis", place: "瑞士・琉森湖", text: "排毒與身體修復，住幾晚就看得到改變" },
  { name: "臺北嘉佩樂酒店 Capella", place: "台灣・台北", text: "「煥活旅程」專案，用 AI 健身設備量測健康年齡，搭配客製芳療" },
  { name: "晶華國際酒店集團", place: "台灣・台北／北投／台南", text: "獲日本健康旅遊認證，推出壓力檢測、體能訓練、溫泉代謝等樂活專案" },
  { name: "日月潭涵碧樓", place: "台灣・南投", text: "以四季養生為核心，推出季節性養生住房之旅" },
];

const Gallery = () => (
  <div className="mt-14 grid gap-3 md:grid-cols-[1.6fr_1fr] md:grid-rows-2">
    <img src={IMAGES[0]} alt="無邊際泳池" className="h-72 w-full rounded-2xl object-cover md:row-span-2 md:h-full" />
    <img src={IMAGES[1]} alt="湖畔晨光" className="h-56 w-full rounded-2xl object-cover object-top" />
    <img src={IMAGES[2]} alt="山景湯池" className="h-56 w-full rounded-2xl object-cover" />
  </div>
);

export const OneMoreThing = () => (
  <section id="one-more-thing" data-testid="one-more-thing" className="bg-[#12100E] text-white">
    <OmtScroll />
    <div className="mx-auto max-w-6xl px-5 pb-24 md:pb-32">
      <p className="max-w-2xl text-base text-white/70 md:text-lg">名人堂已經有的設施，換一個說法，就是全台灣最有條件的抗老度假地。</p>
      <div className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-2xl bg-white/10 md:grid-cols-4">
        {HAVE.map((h) => (
          <div key={h.to} className="bg-[#12100E] p-5">
            <p className="text-xs text-white/50">{h.from}</p>
            <p className="mt-1 text-lg font-black text-[#E9D3A4]">→ {h.to}</p>
          </div>
        ))}
      </div>
      <Gallery />
      <p className="mt-16 text-sm font-bold tracking-[0.3em] text-[#C9A96E]">已經在做的飯店</p>
      <ul className="mt-4 divide-y divide-white/10 border-y border-white/10">
        {EXAMPLES.map((e, i) => (
          <li key={e.name} data-testid={`omt-example-${i}`} className="grid gap-1 py-5 md:grid-cols-[1.1fr_0.7fr_1.6fr] md:items-baseline md:gap-6">
            <p className="text-lg font-black">{e.name}</p>
            <p className="text-sm text-[#C9A96E]">{e.place}</p>
            <p className="text-sm text-white/70">{e.text}</p>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
